import { humanizeEnum } from './format';

/**
 * Plain-English labels for the merchandising and commercial enums, so chips, lists and details
 * never show raw constants like `PARTIALLY_SHIPPED`. Everything not listed here falls back to
 * `humanizeEnum` (`ON_BOARD` -> `On board`).
 */
const OVERRIDES: Record<string, string> = {
    // trade terms are always upper case
    FOB: 'FOB', CIF: 'CIF', CFR: 'CFR', EXW: 'EXW', FCA: 'FCA', DAP: 'DAP', DDP: 'DDP',
    // sample types
    LAB_DIP: 'Lab dip', SIZE_SET: 'Size set', PP: 'Pre-production (PP)', TOP: 'Top of production (TOP)',
    // status words that read wrong when lower-cased
    OK: 'OK', TNA: 'TNA', EXP: 'EXP',
    // costing
    CM: 'CM (cut and make)',
};

/** A merchandising/commercial enum value as a label; blank renders `—`. */
export const enumLabel = (value: string | null | undefined): string => humanizeEnum(value, OVERRIDES);
